export const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;
export const daysOfWeekShort = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"] as const;
export const daysOfWeekAbbreviated = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;

export const dayOfWeekIndexes = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6,

  Mon: 0,
  Tue: 1,
  Wed: 2,
  Thu: 3,
  Fri: 4,
  Sat: 5,
  Sun: 6,

  Mo: 0,
  Tu: 1,
  We: 2,
  Th: 3,
  Fr: 4,
  Sa: 5,
  Su: 6,
};

export type DayOfWeek = (typeof daysOfWeek)[number];
export type DayOfWeekShort = (typeof daysOfWeekShort)[number];
export type DayOfWeekAbbreviated = (typeof daysOfWeekAbbreviated)[number];
